export const smallHeaderHeight = '60px'
export const largeHeaderHeight = '70px'